"use strict";

var curry = require("./curry.js");

var reduce = require("./reduce.js");

function incSel(parent, k) {
  parent[k] ? parent[k]++ : parent[k] = 1;
  return parent;
}

module.exports = curry(function countBy(f, iter) {
  return reduce((counts, a) => incSel(counts, f(a)), {}, iter);
});